import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Controls from "../controls/Controls";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    position: "absolute",
    top: theme.spacing(5),
  },
}));

export default function Popup(props) {
  const { title, children, openPopup, handleOpenPopup, size } = props;
  return (
    <BootstrapDialog open={openPopup} fullWidth maxWidth={size || "xl"}>
      <DialogTitle>
        <Box display="flex">
          <Typography variant="h6" sx={{ flexGrow: 1, mt: 0.5 }}>
            {title}
          </Typography>
          <IconButton
            color="error"
            component="span"
            onClick={() => handleOpenPopup(null)}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>{children}</DialogContent>
      {/* <DialogActions>
        <Controls.Button
          text="Save"
          type="submit"
        ></Controls.Button>
      </DialogActions> */}
    </BootstrapDialog>
  );
}
